import React, { useLayoutEffect ,useEffect } from "react";
import "./App.css";
import PublicRoutes from "./Route/PublicRoutes";
import "react-loading-skeleton/dist/skeleton.css";
import { gapi } from "gapi-script";

const clientId =
  "522036169424-2l9gea0jf9v4tl26gppi13lv93pg3i5h.apps.googleusercontent.com";

function App() {
  useLayoutEffect(() => {
    const scripts = ["scripts.js"];
    scripts.forEach((link) => {
      const script = document.createElement("script");
      script.src = `/assets/js/${link}?v=${process.env.REACT_APP_VERSION}`;
      script.async = true;
      document.body.appendChild(script);
    });
  }, []);

  useEffect(() => {
    function start () {
      gapi.client.init({
        clientId: clientId,
        score: ""
      })
    }
    gapi.load("client:auth2",start);
  }, []);

  useEffect(() => {
    if ('serviceWorker' in navigator && 'PushManager' in window) {
      navigator.serviceWorker.register('/service-worker.js')
        .then(function(swReg) {
          console.log('Service Worker is registered', swReg);
        })
        .catch(function(error) {
          console.error('Service Worker Error', error);
        });
    }
  }, []);

  return (
    <div className="App">
      <div id="preloader" className="provider-cls">
        <div id="status">
          <img src="/assets/images/logo-h.png" alt="logo" />
        </div>
      </div>
      <PublicRoutes />
    </div>
  );
}

export default App;
